export const getShopifyOrder = async (orderId) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/shopify/order/${orderId}`
  );

  return await response.json();
};
